import React from 'react';

import {useStore} from 'effector-react';

import {useTranslation} from 'react-i18next';

import {ReactComponent as PlusIcon} from 'assets/svg/plus.svg';
import {PermissionAccess} from 'components/common/PermissionAccess';
import {Button, ButtonVariant} from 'components/ui-kit/Button';
import {Icon} from 'components/ui-kit/Icon';
import {isAdmin$} from 'models/auth';
import {balance$} from 'models/profile/billing';
import {UserRoles} from 'types/auth';

import {TableSearch} from '../TableInvoces/SearchFilter';

import {BalanceContainer, Root, SearchContainer} from './styled';

export const BillingHeaderControl = ({
    setShowInvoiceGeneratingModal,
    isSearchable,
}: {
    isSearchable?: boolean;
    setShowInvoiceGeneratingModal?: (show: boolean) => void;
}) => {
    const {t} = useTranslation();
    const balance = useStore(balance$);
    const isAdmin = useStore(isAdmin$);
    return (
        <Root>
            {isSearchable ? (
                <SearchContainer>
                    {isAdmin ? (
                        <>
                            <TableSearch searchField="irn" />
                            <TableSearch searchField="tin" />
                        </>
                    ) : (
                        <TableSearch searchField="id" />
                    )}
                </SearchContainer>
            ) : (
                <BalanceContainer>
                    {t('pages.profile.billing.current')}: {balance}
                </BalanceContainer>
            )}
            <div>
                <PermissionAccess
                    permissions={[]}
                    roleAccess={Object.values(UserRoles).filter(
                        (role) =>
                            role !== UserRoles.ROLE_MPL_ADMIN &&
                            role !== UserRoles.ROLE_MPL_OPERATOR_ADMIN &&
                            role !== UserRoles.ROLE_MPL_OPERATOR,
                    )}
                >
                    <Button
                        variant={ButtonVariant.Normal}
                        size="md"
                        type="button"
                        onClick={() => setShowInvoiceGeneratingModal?.(true)}
                    >
                        {t('pages.profile.billing.invoiceGenerating.buttons.buyCodes')}
                        <Icon
                            style={{marginLeft: '8px'}}
                            source={PlusIcon}
                            width={10}
                            height={10}
                        />
                    </Button>
                </PermissionAccess>
            </div>
        </Root>
    );
};
